<template>
  <Menu
    as="div"
    class="relative"
  >

    <MenuButton
      as="div"
      :style="[showText ? 'min-width: 200px; max-width: 250px;' : '']"
      class="w-full py-3 rounded flex items-center border border-transparent hover:border-gray-300 cursor-pointer bg-transparent"
      :class="[showText ? 'px-4' : '']"
      type="nob"
      v-if="account"
    >
      <ZeitAvatar :account="account" size="36px" font-size="16px" />
      <p class="text-sm whitespace-nowrap truncate text-black dark:text-white ml-4" v-if="showText">
        <span class="font-semibold">{{ account.full_name }}</span><br />
        <span v-if="institution">{{ institution.name }}</span>
      </p>
    </MenuButton>

    <MenuItems
      as="div"
      class="
        absolute bottom-0 left-0 z-50
        bg-white border border-gray-200 rounded-lg shadow text-black
        flex flex-col items-start
        focus:outline-none
      "
      style="width: 270px;"
    >
      <MenuItem
        v-for="link of getLinks()" :key="link.id"
        as="div"
        class="
          w-full
          hover:bg-gray-100
          text-sm font-medium
        "
        :class="link.color || 'text-gray-800'"
      >
        <router-link :to="link.path" class="flex items-center px-4 py-3 w-full">
          <ion-icon v-if="link.icon" :ios="link.icon" :md="link.icon" class="mr-3 text-lg" />
          <div>{{ link.label }}</div>
        </router-link>
      </MenuItem>

      <div v-if="rolesById && account" class="px-4 py-2 flex items-center bg-gray-100 w-full border-b border-t border-gray-300 text-xs">
        Du bist angemeldet als&nbsp;<span class="font-semibold">{{ rolesById.get(account.role) }}</span>
      </div>

      <div class="px-4 py-3 flex items-center bg-gray-100 w-full rounded-b-lg">
        <ZeitAvatar :account="account" size="36px" font-size="16px" class="mr-4" />
        <p class="text-sm whitespace-nowrap truncate">
          <span class="font-semibold">{{ account.full_name }}</span><br />
          <span v-if="institution">{{ institution.name }}</span>
        </p>
      </div>
    </MenuItems>

  </Menu>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";

  import { IonIcon, } from '@ionic/vue';

  import ZeitAvatar from './ZeitAvatar.vue';

  import { accountService, Account } from '../../services/accounts';
  import { institutionStore } from '../../store/institutions';
  import { Institution } from '../../services/institutions';

  import {
    logOutOutline, lockClosedOutline, documentTextOutline, personCircleOutline, business, cashOutline,
  } from 'ionicons/icons';
import { session } from '../../globals/session';
import brand from '@/branding';


  export default defineComponent({
    components: {
      ZeitAvatar,

      Menu,
      MenuButton,
      MenuItems,
      MenuItem,

      IonIcon,
    },
    props: {
      showText: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      let licenseLabel = "Lizenzinformationen";

      let links = [
        {id: "profile", path: '/account/profile/', label: "Profil", icon: personCircleOutline},
        {id: "profile", path: '/account/institution/', label: "Unternehmen", icon: business},
      ] as Array<any>;

      if (brand.id != 'blue' && brand.id != 'red') {
        links.push({id: "license", path: '/account/license/', label: licenseLabel, icon: documentTextOutline, permissions: ['licenses:view']});
      }

      if (brand.id == 'red') {
        links.push({id: "billing", path: '/billing/', label: "Abonnement & Rechnungen", icon: cashOutline, permissions: ['billing:view']});
      }      

      links = links.concat([
        {id: "privacy", path: '/account/data-processing-agreement/', label: "Datenschutz & AVV", icon: lockClosedOutline, roles: ['admin']},
        {id: "logout", path: '/authentication/logout/', label: "Abmelden", icon: logOutOutline, color: "text-red-700"},
      ]);
      

      return {
        institution: undefined as undefined|Institution,
        rolesById: undefined as undefined|Map<string, string>,
        account: undefined as undefined|Account,
        links: links,
      }
    },
    methods: {
      hasAllPermissions(perms: Array<string>): boolean {
        if (!this.account) return false;

        for (const perm of perms) {
          if (this.account.permissions.indexOf(perm) == -1) return false;
        }
        return true;
      },
      hasAnyRole(roles: Array<string>): boolean {
        if (!this.account) return false;

        for (const role of roles) if (this.account.role == role) return true;
        return false;
      },
      getLinks() {
        const account = this.account;
        if (!account) return [];

        let results = this.links;

        // Filter for permissions
        results = results.filter(link => this.hasAllPermissions(link.permissions || []));

        // Filter for role
        results = results.filter(link => this.hasAnyRole(link.roles || [account.role]));

        return results;
      },
    },
    async mounted() {
      // account
      this.account = session.getAccount();

      // roleResponse
      const roleResponse = await accountService.listRoles(1, 1000);
      const rolesById = new Map<string, string>();
      for (const role of roleResponse.data.results) {
        rolesById.set(role.id, role.label);
      }
      this.rolesById = rolesById;

      // institution
      this.institution = session.getInstitution();
    }
  });
</script>
